<script>
import { mapActions } from 'vuex';
import TableView from '@/components/elements/views/TableView';

export default {
    page: {
        title: 'Teachers'
    },

    extends: TableView,

    data() {
        return {
            pageTitle: 'Teachers',
            actions: [
                {
                    icon: 'fas fa-chalkboard',
                    method: 'goToCourses'
                }
            ]
        };
    },

    computed: {
        labels() {
            return [
                { value: 'firstName', width: '200px' },
                {
                    value: 'lastName',
                    width: '200px'
                },
                {
                    value: 'createdAt',
                    type: 'date',
                    filter: 'formatDate',
                    width: '150px'
                }
            ];
        }
    },

    methods: {
        ...mapActions({
            getItems: 'teachers/index',
            deleteItem: 'teachers/destroy'
        }),

        onRowClick({ id }) {
            this.$router.push(`/teachers/${id}/edit`);
        },
        onAddButtonClick() {
            this.$router.push('/teachers/add');
        },

        goToCourses(id) {
            this.$router.push(`/teachers/${id}/courses`);
        }
    }
};
</script>
